import { Button, Form, Input, Modal } from 'antd';
import { IOrderRefundShallow } from 'interfaces/orders';
import { reject } from 'requests/refunds';
import { useModalReturnType } from '@refinedev/core';
import { useState } from 'react';

interface RejectRefundModalProps {
  modal: useModalReturnType;
  refund: IOrderRefundShallow;
  onUpdate: () => void;
}

const RejectRefundModal = ({
  modal,
  refund,
  onUpdate
}: RejectRefundModalProps) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onSubmit = async ({ motive }: { motive: string }) => {
    setLoading(true);

    try {
      await reject({ refundId: refund.id, motive });
      modal.close();
      onUpdate();
    } catch {
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  const onClick = async () => {
    const { motive } = await form.validateFields();

    onSubmit({ motive });
  };

  return (
    <Modal
      title="Rejeitar Reembolso"
      visible={modal.visible}
      onCancel={modal.close}
      footer={[
        <Button key="back" onClick={modal.close}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          danger
          loading={loading}
          onClick={onClick}
        >
          Rejeitar
        </Button>
      ]}
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item label="Motivo" name="motive" required>
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
      <p>Tem certeza que deseja rejeitar esse reeembolso?</p>
      <p>Essa ação é irreversível.</p>
    </Modal>
  );
};

export default RejectRefundModal;
